import { render, staticRenderFns } from "./roleSortModal.vue?vue&type=template&id=717e6209&scoped=true"
import script from "./roleSortModal.vue?vue&type=script&lang=js"
export * from "./roleSortModal.vue?vue&type=script&lang=js"
import style0 from "./roleSortModal.vue?vue&type=style&index=0&id=717e6209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e6209",
  null
  
)

export default component.exports